module.exports = __webpack_public_path__ + "static/media/suplias-eyowo-link.53661007.png";